import { IRoute } from '@sp-types/routeType';
import { useState } from 'react';
import { CloseButton } from '../../../../components/UI-Elements/Buttons/CloseButton';
import { RouteDocumentOverlay } from './RouteDocumentOverlay';
import React from 'react';

interface Props {
  route: IRoute;
  isDarkShade?: boolean;
  isFullScreen?: boolean;
  onClose: () => void;
}
export const RouteDetailsPopup: React.FC<Props> = ({ route, onClose, isDarkShade = false, isFullScreen = false }) => {
  const [isShowRouteDocument, setIsShowRouteDocument] = useState(false);
  const formatPrice = (price: number): string => '$' + price;
  const formatPriceByUnit = (priceInMetricTon: number): string => formatPrice(Math.round(priceInMetricTon));

  const { material, transactionFees, shipping, currency } = route.prices;
  const total = {
    price: material.price + transactionFees.price + shipping.price + currency.price,
    collateral: material.collateral + transactionFees.collateral + shipping.collateral + currency.collateral,
  };
  const cards = [
    { key: 0, title: route.name, data: material },
    { key: 1, title: 'Transaction fees', data: transactionFees },
    { key: 2, title: 'Shipping', data: shipping },
    { key: 3, title: 'Currency', data: currency },
  ];
  return (
    <div>
      <div
        className={`${isFullScreen ? 'fixed' : 'absolute'} left-0 top-0 w-full h-full z-50 opacity-50 ${
          isDarkShade ? 'bg-black' : 'bg-white'
        }`}
        onClick={onClose}
      ></div>
      <div
        className={`left-0 top-0 w-full h-full flex items-center justify-center z-50 ${
          isFullScreen ? 'fixed' : 'absolute'
        }`}
      >
        <div className="bg-white p-3 gap-3 shadow-custom w-[55rem]">
          <div className="flex justify-between w-full text-lg">
            <p>Route details</p>
            <CloseButton onClick={onClose} />
          </div>
          <div className="text-gray-700  justify-start text-sm w-full">{route.description}</div>
          <div className="flex flex-1 gap-2 text-sm overflow-y-auto">
            <div className="flex flex-col py-3">
              <img src="/assets/icons/gray-bg/route.svg" alt="" />
              <p className="text-gray-400 text-sm">Route</p>
            </div>
            {cards.map(({ key, title, data }) => (
              <RouteDetailCard
                key={key}
                title={title}
                price={formatPriceByUnit(data.price)}
                collateral={formatPriceByUnit(data.collateral)}
              />
            ))}

            <RouteDetailCard
              title="Total"
              price={formatPriceByUnit(total.price)}
              collateral={formatPriceByUnit(total.collateral)}
              isRed
            />
          </div>
          <div className="flex gap-3 justify-start items-center w-full h-full">
            <div className="flex flex-col py-3">
              <img src="/assets/icons/gray-bg/risk.svg" alt="" />
              <p className="text-gray-400 text-sm">Risks</p>
            </div>
            <div className="flex flex-1 flex-row gap-3 ">
              <div className="rounded-md border min-w-44 p-3  border-gray-50">Price risk - {route.risk.price}</div>
              <div className="rounded-md border min-w-44 p-3  border-gray-50">
                Operational risk - {route.risk.operational}
              </div>
              <div className="rounded-md border  min-w-44  p-3 border-gray-50">
                Counterparty risk - {route.risk.counterParty}
              </div>
              <div className="rounded-md  min-w-44 p-3   border-1 border-pink-200 ">
                Overall risk - {route.risk.overall}
              </div>
            </div>
          </div>
          <div className="flex w-full justify-end ">
            <button
              className="cursor-pointer "
              onClick={() => {
                setIsShowRouteDocument(true);
              }}
            >
              <p className="text-blue-600 underline">read more</p>
            </button>
          </div>
        </div>
      </div>
      {isShowRouteDocument && <RouteDocumentOverlay setDisplayOverlay={setIsShowRouteDocument} routeId={route.id} />}
    </div>
  );
};

export const RouteDetailCard: React.FC<{
  title: string;
  price: string;
  collateral: string;
  isRed?: boolean;
}> = ({ title, price, collateral, isRed }) => (
  <div className={`flex flex-col rounded-md p-2 gap-2 ${isRed ? 'bg-pink-100' : 'bg-gray-50'}`}>
    <p className="truncate">{title}</p>
    <div className="flex gap-2">
      <div className="flex flex-col gap-2 pe-2 border-r-2 border-r-gray-300 min-w-16">
        <p>{price}</p>
        <p className="text-gray-400 text-sm">Price</p>
      </div>
      <div className="flex flex-col gap-2">
        <p className={collateral === 'N/A' ? 'text-gray-400' : ''}>{collateral}</p>
        <p className="text-gray-400 text-sm">Collateral</p>
      </div>
    </div>
  </div>
);
